import { FaLayerGroup, FaThLarge, FaRoad } from 'react-icons/fa';
import { images } from '../constants';

const pricing = [
  {
    id: 1,
    image: images.plan1,
    icon: <FaLayerGroup />, // Flooring icon
    title: 'Flooring Plan',
    price: 49.00,
    features: [
      'Basic Flooring Installation',
      'Tool Rental',
      'Safety Gear Included',
      '24/7 Support',
      'Priority Service',
    ],
  },
  {
    id: 2,
    image: images.plan2,
    icon: <FaThLarge />, // Tiling icon
    title: 'Tiling Plan',
    price: 99.00,
    features: [
      'Advanced Tiling Installation',
      'Premium Tool Set',
      'Safety Gear Included',
      'Expert Consultation',
      'Priority Service',
    ],
  },
  {
    id: 3,
    image: images.plan3,
    icon: <FaRoad />, // Paving icon
    title: 'Paving Plan',
    price: 149.00,
    features: [
      'Custom Paving Design',
      'Deluxe Tool Set',
      'Safety Gear Included',
      'On-Site Assistance',
      'Priority Service',
    ],
  },
];

export default pricing;